import useJobSurge from '../hooks/useJobSurge';

import ManageSurgePayModal from './ManageSurgePayModal';

type Props = { jobId: number | string; onClose: () => void };

/**
 * Manage surge pay opened from somewhere that holds only a job id — the
 * Dashboard V2 panel's ⋮ menu (GRAVY-10443; Figma 38726:44538). Loads the
 * job's schedule, then hands over to the dialog; nothing renders until it has
 * one, so the form never opens on an empty schedule and saves over the real
 * one.
 */
const ManageJobSurge = ({ jobId, onClose }: Props) => {
  const { data, apply } = useJobSurge(jobId);
  if (!data) return null;

  return <ManageSurgePayModal surge={data} onSaved={apply} onClose={onClose} />;
};

export default ManageJobSurge;
